import styled from 'styled-components';
import { theme } from '@frameio/vapor';
import { IconChevronDown } from '@frameio/vapor-icons';

const { eases, durations } = theme.transitions;

export const CHEVRON_WIDTH = 16;

export const Chevron = styled(IconChevronDown)<{ $isOpen: boolean }>`
  min-width: ${theme.spaces[CHEVRON_WIDTH]};
  transform: ${(p) => (p.$isOpen ? 'rotate(0deg)' : 'rotate(-90deg)')};
  transition: all ${durations[200]} ${eases.primary};
`;
